import React, { useCallback, useEffect, useState } from "react"
import { changeAccessToken, changeUserName, changeUserEmail } from "./store/slices/MSALSlice"
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser"
import { appVersion, localStorageNames, scope, setThemeColors } from "./const"
import { changeCurrentUserValue } from "./store/slices/APIResponseSlice"
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentUser } from "./services/ApiServices"
import { loginRequest } from "./authConfig"
import "./App.css"

import Loader from "./components/Loader/Loader"
import Header from "./components/Header/Header"
import Body from "./components/Body/Body"

export default function App() {
  const currentUser = useSelector((state) => state.APIResponse.CurrentUser)
  const accessToken = useSelector((state) => state.MSALAuth.accessToken)

  const [isLoading, setIsLoading] = useState(false)

  const { instance, inProgress, accounts } = useMsal()

  const dispatch = useDispatch()

  useEffect(() => {
    if (currentUser?.Theme) {
      setThemeColors(currentUser?.Theme)
    }
  }, [currentUser?.Theme])

  const setAccessTokenData = useCallback((accessTokenResponse) => {
    // Acquire token silent success
    const accessToken = accessTokenResponse.accessToken

    localStorage.setItem(localStorageNames?.tokenName, accessToken)
    window.accessToken = accessToken

    dispatch(changeAccessToken(accessToken))
  }, [dispatch])

  // Get Current User Data
  useEffect(() => {
    let subscribed = true

    if (accessToken) {
      getCurrentUser().then((response) => {
        if (subscribed) {
          if (typeof response === "object" && !response?.ExceptionMessage && !response?.Message) {
            dispatch(changeCurrentUserValue(response))
          } else {
            dispatch(changeCurrentUserValue({}))
          }
        }
      }).catch((error) => {
        if (subscribed) {
          console.warn(error)
        }
      }).finally(() => {
        if (subscribed) {
          setIsLoading(false)
        }
      })
    }

    return () => {
      subscribed = false
    }
  }, [dispatch, accessToken])

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      dispatch(changeUserName(accounts[0] ? accounts[0]?.name : ""))
      dispatch(changeUserEmail(accounts[0] ? accounts[0]?.username : ""))
    }
  }, [dispatch, accounts])

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      const accessTokenRequest = { scopes: [scope], account: accounts[0] }

      if (accounts && accounts?.length > 0) {
        instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse) => {
          setAccessTokenData(accessTokenResponse)
        }).catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest)
          }
          console.error(error)
        })
      } else {
        instance.loginRedirect(loginRequest).catch((error) => {
          console.error(error)
        })
      }
    }
  }, [instance, accounts, inProgress, setAccessTokenData])

  return (
    <AuthenticatedTemplate>
      {!isLoading && currentUser && Object.keys(currentUser)?.length > 0 ? (
        <>
          <Header />
          <Body />
        </>
      ) : (
        <Loader />
      )}
      {appVersion && (
        <div
          className="position-fixed"
          style={{
            right: "3px",
            bottom: "0px"
          }}
        >
          <span style={{ fontSize: "small", color: "gray" }}>
            {appVersion}
          </span>
        </div>
      )}
    </AuthenticatedTemplate>
  )
}